import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
// import { changeLanguage } from "../../actions/language";
import { changeLanguage } from '../../../actions/language';
import { injectIntl, FormattedMessage } from 'react-intl';
import propTypes from 'prop-types';
// import { getValue } from "../../utils/utility/booking";
import { getValue } from '../../../utils/utility/booking';
import './dropDown.scss';
let searchDataLength = 0;
import { ChevronDownIcon, ChevronUpIcon } from '~svg';
class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenOption: false,
      selected: null,
      search: '',
      suggestion: '',
      indexOfOption: 0,
    };
    this.node = React.createRef();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.value &&
      (nextProps.value != this.props.value || !this.state.selected)
    )
      this.findSendValueInDataOfDropDown(
        nextProps.value,
        nextProps.options.data,
      );
  }
  // componentWillMount() {
  //   // document.addEventListener("keypress", this.logKey);
  // }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleclick);
    this.findSendValueInDataOfDropDown(this.props.value);
  }
  componentDidUpdate = (prevProps, prevState) => {
    if (!this.props.value && prevState.selected)
      this.setState({ selected: '' });
  };
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleclick);
  }
  arrayToObject = (array) =>
    array.reduce((obj, item) => {
      obj[item['0']] = item;
      return obj;
    }, {});
  findSendValueInDataOfDropDown = (newValue, data) => {
    if (!data) data = this.props.options.data;
    let { value } = this.props.options;
    let selected;
    switch (typeof newValue) {
      case 'string':
      case 'number':
        selected =
          data &&
          data.filter((item) => {
            return item[value] === newValue;
          });
        break;
      case 'object':
        selected =
          data &&
          newValue &&
          Object.entries(newValue).length &&
          data.filter((item) => {
            return Array.isArray(newValue)
              ? item[value] === newValue[0][value]
              : item[value] === newValue[value];
          });

        break;

      default:
        break;
    }

    if (selected && selected.length > 0) {
      const peopleObject = this.arrayToObject(selected);
      this.setState({ selected: peopleObject['undefined'] });
    }
  };
  onOption = (item) => {
    const { onChange, name, options } = this.props;
    const { value } = this.props.options;
    const { search, indexOfOption } = this.state;

    let selected = search
      ? this.searchData() && this.searchData().length > 0
        ? this.searchData()[indexOfOption]
        : item
      : item;
    this.setState(
      {
        selected: { ...selected, stateName: name },
        isOpenOption: false,
        suggestion: null,
      },
      () => {
        let event = {
          currentTarget: {
            value: selected?.[value],
            // value: this.state.selected[value],
            name: this.props.name,
            valueObject: item,
          },
        };
        onChange(event);
      },
    );
  };
  onChangeInput = (event) => {
    let suggestion = '';
    let phrase = event.target.value;
    let { options, hasChild, language } = this.props;
    let { data, label, isMultiLanguage } = options;

    if (phrase.length) {
      let tmp = data.filter((item) => {
        if (typeof item === 'object') {
          if (hasChild) {
            // console.log("onChange ---- getValue", getValue(item, hasChild));
            // let lodash = getLodash(item, hasChild);
            let lodash = getValue(item, hasChild);
            return lodash;
          } else if (item[label])
            return isMultiLanguage
              ? item[label][language.name].toLowerCase().indexOf(phrase) === 0
              : item[label].toString().toLowerCase().indexOf(phrase) === 0;
        } else return item[label].indexOf(phrase) === 0;
      });
      if (tmp.length > 0) {
        if (hasChild) {
          //   let lodash = getLodash(tmp[0], hasChild);
          let lodash = getValue(tmp[0], hasChild);
          suggestion = lodash[label].toLowerCase();
        } else if (typeof tmp[0] === 'object')
          suggestion = isMultiLanguage
            ? tmp[0][label][language.name].toLowerCase()
            : tmp[0][label].toString().toLowerCase();
        else suggestion = tmp[0].toLowerCase();
      }
    }

    this.setState({
      search: phrase,
      suggestion,
      indexOfOption: 0,
    });
  };
  renderListOptionShow = (item) => {
    let { label, value, isMultiLanguage } = this.props.options;
    let { name } = this.props.language;
    if (typeof item[label] === 'object')
      return isMultiLanguage ? item[label][name] : item.label;
    else {
      //   return getLodash(item, label);
      return getValue(item, label);
    }
  };
  renderListOption = (search) => {
    let { label } = this.props.options;
    let { indexOfOption } = this.state;
    let { theme } = this.props;
    const hover =
      theme === 'light' || theme === 'flight'
        ? 'dropDownComponentHover'
        : 'dropDownComponentHoverDark';

    return search.map((item, index) => {
      //   console.log("----renderListOption----", item, label);
      //   console.log("----renderListOption getLodash----", getLodash(item, label));
      //   console.log("----renderListOption---- getValue", getValue(item, label));
      //   if (item && getLodash(item, label) !== null)
      if (item && getValue(item, label) !== null)
        return (
          <div
            key={index}
            onClick={() => {
              this.props.options?.data && this.onOption(item);
            }}
            onMouseEnter={() => {
              this.setState({ indexOfOption: index });
            }}
            className={`col px-3 py-3 d-flex flex-start cursor-pointer text-dark ${
              this.props.optionClass
            } ${
              index === search.length - 1
                ? 'border-0'
                : 'border-bottom border-third'
            } ${index === indexOfOption ? hover : ''} `}
          >
            {this.renderListOptionShow(item)}
          </div>
        );
    });
  };

  findInAllLanguage = (item, label, search) => {
    if (
      item[label]['en'].toLowerCase().indexOf(search.toLowerCase()) > -1 ||
      (item['index'] &&
        item['index'].toString().toLowerCase() === search.toLowerCase())
    )
      return item;
    if (
      item[label]['fa'].toLowerCase().indexOf(search.toLowerCase()) > -1 ||
      (item['index'] &&
        item['index'].toString().toLowerCase() === search.toLowerCase())
    )
      return item;
  };

  searchData = () => {
    const { options, isDbsearch } = this.props;
    const { label, data, isMultiLanguage } = options;
    const { search } = this.state;
    const searchData = data.filter((item) => {
      if (item && item[label])
        return isMultiLanguage
          ? this.findInAllLanguage(item, label, search)
          : item[label].toString().toLowerCase().indexOf(search.toLowerCase()) >
              -1 ||
              (item['index'] &&
                item['index'].toString().toLowerCase() ===
                  search.toLowerCase());
    });
    searchDataLength = searchData.length;
    if (search.length >= 3 && isDbsearch) this.props.returnSearchPhrase(search);
    else return searchData;
  };

  renderOption = () => {
    let { isOpenOption, search } = this.state;
    let { hasChild, options, theme } = this.props;
    let searchData = options.data;
    if (options && hasChild) {
      searchData = options.map((item) => {
        // return getLodash(item, hasChild);
        return getValue(item, hasChild);
      });
    }

    //searchData = getChild;
    if (isOpenOption) {
      // let searchData = hasChild ? getChild : data;
      if (search.length > 0) {
        searchData = this.searchData();
      }

      return (
        <div
          className={`col bg-third-light text-white p-0 d-flex flex-column justify-content-start  position-absolute default-border-bottom-radius-small ${
            theme === 'light' || theme === 'flight' ? 'bg-white' : ''
          }`}
          id={'dropDownOptionList'}
          style={{
            // color: "#999",
            // border: selected ? "1px solid #00c853" : "1px solid #ccc",
            borderTopWidth: '0px',
            borderRadius: '0 0 4px 4px',
            border: '1px solid rgb(189, 198, 243)',
            zIndex: 20000,
            maxHeight: '227px',
            overflowY: 'auto',
            direction: this.props.direction ? 'rtl' : '',
          }}
        >
          {searchData &&
            searchData.length > 0 &&
            this.renderListOption(searchData)}
        </div>
      );
    } else return null;
  };
  renderLabel = () => {
    let { selected } = this.state;
    let {
      label,
      language,
      isMobile,
      icon,
      optionClass,
      theme,
      outSideLabel,
      labelPosition,
    } = this.props;
    let field = this.props.options?.label;
    let { isMultiLanguage } = this.props.options;

    if (selected) {
      return (
        <div
          className={`w-100 text-truncate text-start ${
            outSideLabel ? 'py-2 font-small' : 'pt-1'
          }`}
        >
          {!isMobile && !icon && !outSideLabel && theme !== 'flight' ? (
            <div
              className={`font-smaller position-absolute ${
                theme === 'flight'
                  ? ''
                  : theme === 'light'
                  ? 'text-success'
                  : 'text-greenish-blue'
              }`}
              style={{
                top: '-40%',
                right:
                  language.name === 'fa'
                    ? this.props.isMobile
                      ? '-9%'
                      : '0'
                    : '',
                left:
                  language.name === 'fa'
                    ? ''
                    : this.props.isMobile
                    ? '-9%'
                    : '0',
              }}
            >
              <FormattedMessage id={label} />
            </div>
          ) : (
            <></>
          )}
          <span
            className={`w-100 text-truncate ${
              theme === 'light' || theme === 'flight'
                ? 'text-dark'
                : 'text-dark'
            }  ${optionClass} `}
          >
            {/* {console.log(
              "----renderlabe;---- getValue",
              !isMultiLanguage ? getValue(selected, field) : "ss"
            )} */}
            {/* {isMultiLanguage
              ? selected[field][language.name]
              : getLodash(selected, field)} */}
            <span className="w-100 text-truncate">
              {isMultiLanguage
                ? selected?.[field]?.[language.name]
                : getValue(selected, field)}
            </span>
          </span>
        </div>
      );
    } else if (!outSideLabel) return <FormattedMessage id={label} />;
  };
  renderSelectedLabelAndDefaultLabel = () => {
    return (
      <span
        style={{ color: this.props.isMobile ? '#d4cfcf' : '' }}
        className={`${
          !this.props.isMobile && this.props.icon
            ? 'col-8 text-white '
            : 'col-11 '
        } p-0 d-flex flex-start justify-content-start align-items-center ${
          this.state.selected
            ? 'font-medium'
            : this.props.isMobile
            ? 'font-large'
            : 'font-small'
        }`}
      >
        {this.renderLabel()}
      </span>
    );
  };
  renderSearchAndLabel = () => {
    let { isOpenOption, suggestion } = this.state;
    let { theme } = this.props;
    if (isOpenOption)
      return (
        <div
          className={
            'col p-0 d-flex justify-content-center align-items-center position-relative'
          }
        >
          <input
            type="text"
            value={(isOpenOption && suggestion) || ''}
            className={`col px-0 py-2 rounded  outline-0 border-0  bg-transparent ${
              this.state.selected ? 'font-medium' : 'font-small'
            }  ${
              theme === 'light' || theme === 'flight'
                ? 'text-dark'
                : 'text-white'
            }`}
            onChange={() => {}}
          />
          <input
            style={{ direction: this.props.direction ? 'rtl' : '' }}
            type="text"
            autoFocus={true}
            onChange={this.onChangeInput}
            placeholder={this.props.intl.formatMessage({
              id: 'booking.search',
            })}
            className={`col px-0 py-2 rounded  outline-0 position-absolute bg-transparent border-0 ${
              this.state.selected ? 'font-medium' : 'font-small'
            }  
            ${
              theme === 'light' || theme === 'flight'
                ? 'text-dark'
                : 'text-dark'
            }`}
          />
        </div>
      );
    else return this.renderSelectedLabelAndDefaultLabel();
  };
  onClickSelect = () => {
    this.setState((prevState) => ({
      isOpenOption: !prevState.isOpenOption,
      indexOfOption: 0,
      search: '',
    }));
  };
  handleclick = (e) => {
    if (this.node && this.node.contains(e.target)) return;
    else this.setState({ isOpenOption: false });
  };
  openOptionOfDropDownWithKeyPress = (item) => {
    this.setState({ isOpenOption: item, indexOfOption: 0 });
  };
  render() {
    let {
        tabIndex = 0,
        onClick = () => {},
        id,
        name,
        options,
        error,
        customeStyle,
        customeClassName,
        isDbsearch,
        maxHeight = '75px',
        icon = null,
        theme = 'light',
        labelPosition = 'top',
        outSideLabel = false,
        outSideLabelClass = '',
        withoutShadow,
        isMobile,
        label,
        backgroundClass = '',
        iconNameDrp,
        iconSize,
        ...rest
      } = this.props,
      className = `py-0 ${outSideLabel ? 'my-2' : 'my-2'} ${
        isMobile ? 'px-0' : ''
      }`,
      { isOpenOption, indexOfOption, search } = this.state;

    const border =
      theme === 'flight' || (!isMobile && icon)
        ? 'border-0'
        : theme === 'light'
        ? ''
        : 'dark-border-dropdown';
    return (
      <div
        className={`w-100 position-relative ${backgroundClass}`}
        tabIndex={tabIndex}
        id={name}
        // onFocus={() =>
        //   !withoutShadow &&
        //   $(`#${name} , #dropDownOptionList`).addClass("inputBoxShadow")
        // }
        // onBlur={() =>
        //   !withoutShadow &&
        //   $(`#${name} , #dropDownOptionList`).removeClass("inputBoxShadow")
        // }
        onKeyDown={(e) => {
          let optionsDiv = document.getElementById('dropDownOptionList');
          if (e.key === 'Enter' || e.keyCode === 32) {
            const filteredData =
              search.length > 0 ? this.searchData() : options.data;
            this.onOption(filteredData[this.state.indexOfOption]);
          }
          if (e.key === 'ArrowDown' && isOpenOption === false) {
            this.openOptionOfDropDownWithKeyPress(true);
          } else if (
            e.key === 'ArrowDown' &&
            isOpenOption === true &&
            indexOfOption <
              (search.length > 0 ? searchDataLength : options.data.length) - 1
          ) {
            if (search) {
              if (indexOfOption + 1 < searchDataLength)
                this.setState(
                  (state) => ({ indexOfOption: state.indexOfOption + 1 }),
                  () => {
                    if (this.state.indexOfOption > 2)
                      optionsDiv.scrollTop += 57;
                  },
                );
            } else
              this.setState(
                (state) => ({ indexOfOption: state.indexOfOption + 1 }),
                () => {
                  if (this.state.indexOfOption > 2) optionsDiv.scrollTop += 57;
                },
              );
          } else if (
            e.key === 'ArrowUp' &&
            isOpenOption === true &&
            indexOfOption > 0
          ) {
            this.setState(
              (state, props) => ({ indexOfOption: state.indexOfOption - 1 }),
              () => {
                if (
                  indexOfOption <
                  (search.length > 0 ? searchDataLength : options.data.length) -
                    3
                )
                  optionsDiv.scrollTop -= 57;
              },
            );
          }
        }}
        ref={(event) => (this.node = event)}
        style={{
          borderRadius: `${
            !this.props.isMobile && this.props.icon ? '24px' : ''
          }`,
          outline: 'none',
          direction: this.props.direction ? 'rtl' : '',
        }}
      >
        {outSideLabel ? (
          labelPosition === 'top' ? (
            <div
              className={`text-dark px-3 font-small d-flex w-100 justify-content-start align-items-center pb-2 ${outSideLabelClass}`}
              style={{ outline: 'none' }}
            >
              <FormattedMessage id={label} />
            </div>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
        <div
          className={`heightResponsive ${
            this.props.classNames
          } d-flex  align-items-center justify-content-start cursor-pointer ${
            theme !== 'flight' ? 'px-3' : 'px-0'
          }  ${this.state.selected && theme !== 'flight' ? `${border}` : ''} `}
          onClick={() => {
            this.onClickSelect();
          }}
          style={{
            color: '#999',
            border:
              (outSideLabel && theme === 'flight') || (icon && !isMobile)
                ? 0
                : '1px solid rgb(189, 198, 243)',
            borderBottomWidth: !outSideLabel
              ? isOpenOption
                ? '0px'
                : '1px'
              : theme === 'flight'
              ? 0
              : 1,
            borderRadius: isOpenOption ? '1rem 1rem 0px 0px' : '1rem',
            maxHeight: maxHeight,
            outline: 'none',
            ...customeStyle,
          }}
        >
          {this.props.isMobile ? (
            { icon }
          ) : (
            <div className={`d-flex align-items-center justify-content-center`}>
              {iconNameDrp}
            </div>
          )}
          <div
            className={`w-100 px-2 d-flex align-items-center  ${
              customeClassName ? customeClassName : className
            }`}
          >
            {this.renderSearchAndLabel()}
          </div>
          <div
            className={`p-0 d-flex flex-end ${
              this.props.isMobile
                ? 'justify-content-center'
                : 'justify-content-end'
            } `}
          >
            {isOpenOption ? (
              <ChevronUpIcon color="#aaacaf" size={iconSize} />
            ) : (
              <ChevronDownIcon color="#aaacaf" size={iconSize} />
            )}
          </div>
        </div>
        {this.renderOption()}
      </div>
    );
  }
}
DropDown.propTypes = {
  isDbsearch: propTypes.bool,
  returnSearchPhrase: propTypes.func,
  theme: propTypes.string,
  outSideLabel: propTypes.bool,
  labelPosition: propTypes.string,
  iconNameDrp: propTypes.any,
  iconSize: propTypes.number,
};
DropDown.defaultProps = {
  isDbsearch: false,
  theme: 'light',
  outSideLabel: false,
  labelPosition: 'top',
  returnSearchPhrase: () => {
    console.log(
      'Please Call returnSearchPhrase function to search on data base',
    );
  },
  iconNameDrp: null,
  iconSize: 18,
};
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(
  connect(mapStateToProps, { changeLanguage })(withRouter(DropDown)),
);
